(function () {
  if (window.RgvSuccessPopupLoaded) return;
  window.RgvSuccessPopupLoaded = true;

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function initialiseDialog(dialog) {
    if (!dialog || dialog.dataset.rgvSuccessInitialised === 'true') return;
    dialog.dataset.rgvSuccessInitialised = 'true';

    dialog.querySelectorAll('[data-rgv-success-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeDialog(dialog);
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog(dialog);
    });

    window.requestAnimationFrame(function () {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });
  }

  function initialiseAll(root) {
    root.querySelectorAll('[data-rgv-success-dialog]').forEach(initialiseDialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
